var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g-signin-button',{staticClass:"btn btn-secondary form-control py-2 googleButton",attrs:{"params":_vm.googleSignInParams},on:{"success":_vm.onSignInSuccess,"error":_vm.onSignInError}},[_vm._v(" Continue with Google ")])}
var staticRenderFns = []

export { render, staticRenderFns }